class AttachmentReadability {
  constructor(params) {
    this.fileName = params.fileName;
    this.readabilityScore = new ReadabilityScore(params.readabilityScore);
  }
}

class ReadabilityScore {
  constructor(score) {
    this.isReadable = false;
    this.isBarelyReadable = false;
    this.isUnreadable = false;
    this.isLocked = false;
    switch (score) {
      case 0:
        this.isUnreadable = true;
        break;
      case 1:
        this.isBarelyReadable = true;
        break;
      case 2:
        this.isReadable = true;
        break;
      case 3:
        this.isLocked = true;
    }
  }
}

export { AttachmentReadability as default };
